import { render } from "./BiographyPage.vue?vue&type=template&id=be084caa&scoped=true"
import script from "./BiographyPage.vue?vue&type=script&lang=js"
export * from "./BiographyPage.vue?vue&type=script&lang=js"

import "./BiographyPage.vue?vue&type=style&index=0&id=be084caa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be084caa"]])

export default __exports__